import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: null,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setOpenModalType(state, action) {
      state.type = action.payload;
    },
  },
});

export const { setOpenModalType } = modalSlice.actions;

export default modalSlice.reducer;
